<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar [class]="'mb-2'"></medsurf-design-content-toolbar>
  <!-- iFrame -->
  <div class="flex align-items-center justify-content-center h-screen">
    <iframe
      class="w-full h-full p-6 border-none"
      [src]="safeUrl"></iframe>
  </div>
</div>
